import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useSupplierCountryContext() {
  const { supplierCountries } = useContext<GlobalContextType>(GlobalContext);
  return supplierCountries;
}
